import { isWHWP2, getSession, viewport, getWHWSpoCookie } from '../../../../../common/Helpers';

export const generateVdsButtonProps = (clickListener, name, ariaLabel, type, otherProps) => ({
  buttonGroup: {
    childWidth: '248px',
    data: [
      {
        use: 'secondary',
        children: name,
        ariaLabel,
        onClick: clickListener,
        disabled: type === 'vzProtectHome' && otherProps.vzAddonsInCart && !otherProps.tileData.quantity,
      },
    ],
  },
});

const WHWRedeemAction = (otherProps) => {
  let buttonAction;
  let whwSpoDetails;
  if (isWHWP2()) {
    const whwSpoDetailsSession = viewport() === 'mfapp' ? getWHWSpoCookie('whwSpoDetails') : getSession('whwSpoDetails');
    whwSpoDetails = whwSpoDetailsSession && JSON.parse(whwSpoDetailsSession);
  }

  const extOnProfile = whwSpoDetails?.extenderOnProfile;
  if (extOnProfile) {
    buttonAction = otherProps?.whwTilesData?.quantity;
    // } else if (extOnProfile === '1') {
    //   buttonAction = otherProps.whwTilesData.quantity
    // } else {
    //   buttonAction = !otherProps.whwTilesData.quantity
  }
  return buttonAction;
};

export const generateWhwButtonProps = (clickListener, name, ariaLabel, type, otherProps) => ({
  buttonGroup: {
    childWidth: '248px',
    data: [
      {
        use: 'secondary',
        children: name,
        ariaLabel,
        onClick: clickListener,
        disabled: type === 'whwServices' && otherProps?.whwTilesData && isWHWP2() ? WHWRedeemAction(otherProps) : otherProps?.whwTilesData?.quantity,
      },
    ],
  },
});

export const generateSteepingInputProps = (changeListener, maxValue, prevQuantity) => ({
  inputStepper: {
    defaultValue: prevQuantity || 1,
    minValue: 0,
    maxValue: isWHWP2() ? 2 : maxValue || 10,
    width: '248px',
    controlWidth: '100%',
    onChange: changeListener,
    trailingText: isWHWP2() ? ' extender' : '',
    ...(isWHWP2() && { ariaLabel: { decrement: 'Remove : extender', increment: 'Add : extender' } }),
  },
});

/*
 * Cloned from showTileData in streamingDevice.js
 */
export const generateButtonQtyProps = (onRemovingStreamTV, buttonSelectState, displayName, quantity, planInfo, skuDetails, parentProps) => ({
  isAddonsPage: true,
  onChangingStreamTV: onRemovingStreamTV,
  buttonSelectState,
  name: displayName,
  quantity,
  prodId: skuDetails && skuDetails?.sorId ? skuDetails?.sorId : skuDetails?.productId,
  postAccessory: parentProps,
  maxQuantity: isWHWP2() ? '2' : planInfo && planInfo?.maximumQuantity ? planInfo.maximumQuantity : '10',
  WHWRedemption: isWHWP2(),
});
